<template>
  <v-data-table
    v-bind="tableProps"
    dense
    :headers="headers"
    :items="data"
    :loading="loading"
    @click:row="onRowClick"
  >
    <template v-slot:[`item.warehouse_id`]="{ item }">
      {{ item.warehouse_id[1] }}
    </template>
    <template v-slot:[`item.type_pv`]="{ item }">
      {{ item.type_pv[1] }}
    </template>
    <template v-slot:[`item.brand_id`]="{ item }">
      {{ item.brand_id[1] }}
    </template>
  </v-data-table>
</template>

<script>
import { useDataTable } from "@/composables/api/data-table.js";
import { inject } from "vue-demi";

export default {
  setup() {
    const { data, loading, headers, tableProps } = useDataTable("customer");

    const showOnMap = inject("showOnMap");

    const onRowClick = item => {
      showOnMap({
        measure: "customer",
        brand_id: item.brand_id[0],
        warehouse_id: item.warehouse_id[0],
        type_pv_id: item.type_pv[0]
      });
    };

    return {
      data,
      loading,
      headers,
      onRowClick,
      tableProps
    };
  }
};
</script>

<style></style>
